import React, { useContext, useEffect, useState } from 'react'
import Slider from '../Slider'
import RecentWatch from '../RecentWatch'
import Header from '../Header'
import axios from 'axios'
import Loader from '../Loader/Loader'
import Languages from './Languages'
import Genres from './Genres'
import Footer from '../Footer'
import { SearchGlobalContext } from '../Search/SearchGlobalContext'
import Search from '../Search/Search'
import HomeSliderSection from './HomeSliderSection'
import HomeSection from './HomeSection'
import SliderV2 from '../SliderV2'
import SliderV3 from '../SliderV3'
const Home = () => {
  const [sliders, setSlider] = useState([])
  const [recentlywatched, setRecentlyWatched] = useState([])
  const [homeslidersection, setHomeSliderSection] = useState([])
  const [homesection, setHomeSection] = useState([])
  const [loading, setLoading] = useState(true);
  const [planStatus, setPlanStatus] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [genres, setGenres] = useState([]);
  const {searchResults} = useContext(SearchGlobalContext)
  useEffect(() => {

    getHomePageData()
    recentlyWatched()
    utmSourceData()
    const pc = localStorage.getItem('plan_active');
    setPlanStatus(pc)
    // console.log(localStorage.getItem('user_id'));
  },  [])



  const utmSourceData = async () => {
  
    const params = new URLSearchParams(window.location.search);
    // Read utm_source (will include the quotes if they’re in the URL)
    const utm_source = params.get('utm_source');
    const utm_medium = params.get('medium');
    const utm_campaign = params.get('campgain');
    const click_id = params.get('click_id');
    localStorage.setItem('utm_source',utm_source)
    localStorage.setItem('utm_medium',utm_medium)
    localStorage.setItem('utm_campaign',utm_campaign)
    localStorage.setItem('utm_click_id',click_id)
    console.log(utm_source,utm_medium,click_id,utm_campaign);
    const reqData = {
      utm_source,
      utm_medium,
      utm_campaign,
      click_id
    }
    await axios.post(`${process.env.REACT_APP_API_URL}/storeUtmData`, JSON.stringify(reqData)).then((response) => {
  
    })
  }


  const getHomePageData = async () => {
    setLoading(true)
    const reqData = {
      phone:localStorage.getItem('phone') != null ? localStorage.getItem('phone') : '9999999999'
    }
    await axios.post(`${process.env.REACT_APP_CONTENT_URL}/homeV2`, JSON.stringify(reqData)).then((response) => {
      setLoading(false)
      const obj = response.data.data;
      console.log(obj);
      
      setSlider(obj.slider)
      setHomeSliderSection(obj.home_slider_sections)
      setHomeSection(obj.home_sections)
      setLanguages(obj.language)
      setGenres(obj.genres)
    })
  }
  const recentlyWatched = async () => {
    setLoading(true)
    const reqData = {
      phone:localStorage.getItem('phone') != null ? localStorage.getItem('phone') : '9999999999'
    }
    let formData = new FormData();
    formData.append('data[salt]', process.env.REACT_APP_API_SALT);
    formData.append('data[sign]', process.env.REACT_APP_API_SIGN);
    formData.append('data[user_id]', localStorage.getItem('user_id') != null ? localStorage.getItem('user_id') : 271);
    axios.post(`${process.env.REACT_APP_CONTENT_URL}/recentlyWatched`, reqData).then((response) => {
      setLoading(false)
      // console.log(response.data.data.recently_watched);
      setRecentlyWatched(response.data.data.recently_watched)
     
    })
  }
  return (
    <>
      {loading ?
        (
          <Loader loading={loading} />) : (
          <>
            <Header />
            {
              searchResults.length > 0 ? (<Search />) : (
                <>
                  <Slider sliders={sliders} />
                  {/* <SliderV2 sliders={sliders}  /> */}
                  {/* <SliderV3 sliders={sliders}  /> */}
                  {/* <TopTrendingMovies toptrendings={topTrendings} /> */}
                  {
                    localStorage.getItem('phone') > 0 ? (
                      <RecentWatch recentlywatched={recentlywatched} />
                    ) :
                      (
                        ''
                      )
                  }
                  <HomeSliderSection homeslidersection={homeslidersection} />
                  <Genres genres={genres} />
                  <Languages movies={languages} />
                  <HomeSection homesection={homesection}/>
                 
                  <Footer />
                </>
              )
            }
          </>
        )}
    </>
  )
}
export default Home